<template>
  <div class="new_list">
    <div class="banner_sw">
      <swiperx :swiperOptions="swiperOptions_sw">
        <template #slides>
          <swiper-slide>
            <router-link to="/activity">
              <img v-if="img!=''"
                :src="img"
                style="width: 100%"
                width="100%"
              />
            </router-link>
            <!-- <img :src="item.imagePath" alt="" width="100%" /> http://xiaofu2023.oss-accelerate.aliyuncs.com/img/img_home_custom_goods.47705380.png?v===1 -->
          </swiper-slide>
          <swiper-slide>
            <router-link to="/activity">
              <div class="box">
                <p class="title">购物新体验</p>
                <p class="des des1">购物赠送积分</p>
                <p class="des des2">积分换取商品</p>
                <p class="img">
                  <img
                    src="http://xiaofu2023.oss-accelerate.aliyuncs.com/img/yuqi.c37a64f0.e468ea8e.png"
                  />
                </p>
                <!-- <p class="go">去体验 <img src="http://xiaofu2023.oss-accelerate.aliyuncs.com/img/go.png" /></p> -->
              </div>
            </router-link>
          </swiper-slide>
        </template>
      </swiperx>
    </div>
    <div class="announce">
      <router-link to="/pointsMall/lottery" class="new_announce item" >
        <p class="title" style="font-weight: bold">最新揭晓</p>
        <div v-if="index_lottery?.times > 0">
          <VueCountdownTimer
            class="van-count-down"
            ref="cxlCountdown"
            :time="index_lottery?.times * 1000 || 0"
            :interval="1000"
            :emit-events="events"
            :format="transform"
            :enableVisibilityHiddenFix="true"
            @finish="finish"
          >
            <template v-slot="props">
              <span class="minutes block" v-text="props.minutes" />
              <span class="separator colon">:</span>
              <span class="seconds block" v-text="props.seconds" />
              <span class="separator colon">:</span>
              <span class="countdown-number block" />
            </template>
          </VueCountdownTimer>
        </div>

        <!-- <van-count-down
          v-if="index_lottery?.times > 0"
          :time="index_lottery?.times * 1000 || 0"
          millisecond
          format="mm:ss:SS"
          class="count_down"
          @finish="finish"
        >
          <template #default="timeData">
            <span class="block">0{{ timeData.minutes }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeData.seconds }}</span>
            <span class="colon">:</span>
            <span class="block">{{
              String(timeData.milliseconds).padStart(3, "0").substr(0, 2)
            }}</span>
          </template>
        </van-count-down> -->
        <div v-else style="font-size: 0.2rem; text-align: center">
          <p style="color: var(--textColor3)">换得者</p>
          <p
            style="
              color: #000;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            {{ index_lottery?.user.username || "" }}
          </p>
        </div>
        <p
          class="img"
          :style="{
            margin: '0 auto',
            fontSize: '0.15rem',
            width: index_lottery?.times > 0 ? '1.38rem' : '1rem',
          }"
        >
          <img :src="index_lottery?.thumb" :alt="index_lottery?.title || ''" />
        </p>
      </router-link>
      <router-link to="/pointsMall/category"
        class="about_announce item"
      >
        <p class="title" style="font-weight: bold">即将揭晓</p>
        <p class="des" style="color: #000;">快来换取</p>
        <p class="img" style="margin: 0 auto">
          <img :src="open_list?.image" :alt="open_list?.store_name || ''" />
        </p>
      </router-link>
    </div>
  </div>
</template>
<style scoped>
.image-container {
  position: relative;
  display: inline-block; /* 或者根据需要设置为其他值 */
}
 

 
.text-overlay {
  position: absolute;
  top: 50%; /* 垂直居中 */
  left: 50%; /* 水平居中 */
  transform: translate(-50%, -50%); /* 微调位置确保精确居中 */
  color: white; /* 文字颜色 */
  font-size: 24px; /* 文字大小 */
  background-color: rgba(0, 0, 0, 0.5); /* 可选：背景色和透明度 */
  padding: 10px; /* 内边距 */
  border-radius: 5px; /* 可选：圆角边框 */
}
</style>
<script>
import swiperx from "@/components/swiperx.vue";
import { swiperSlide } from "vue-awesome-swiper";
import api from "@/request/api";
export default {
  props: {
    indexData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      events: {
        visibilityVisible: true,
        visibilityHidden: true,
        finish: true,
      },
      time: 20 * 60 * 1000 + 30 * 1000 + 30,
	  img:'',
      swiperOptions_sw: {
        effect: "coverflow",
        slidesPerView: 1,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 200,
          modifier: 1,
          slideShadows: true,
        },
      },
      open_list: null,
      index_lottery: null,
      timer: null,
    };
  },
  components: {
    swiperx,
    swiperSlide,
  },
  
  created() {
  	
  	
  	    const cachedData = JSON.parse(localStorage.getItem('apiData'));
  	
  	
  	    if (cachedData) {
  	
  	
  	     this.img=cachedData.index;
  	
  	
  	    } else {
  	
  	
  	      // 假设我们使用axios进行HTTP请求
  	
  this.getConfigs();
  	
  	
  	    }
  	
  	
  	  },
  mounted() {
	  // this.getConfigs();
    this.getHttp();
	
    var this_ = this;
    this_.getTimer();
    this.timer = setInterval(() => {
      this_.getTimer();
    }, 4000);
  },
  methods: {
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        props[key] = value < 10 ? `0${value}` : value;
      });
      return props;
    },
    go_search(path) {
      this.$router.push({ path: path });
    },
    getTimer() {
      var timestamp = Date.now();
      const timestampWithDecimal = (timestamp / 1000).toFixed(3);
      this.lottery_going_shoplist(
        this.timestampWithDecimal
          ? this.timestampWithDecimal
          : timestampWithDecimal,
        1
      );
    },

	getConfigs() {
		
	  try {
	    var that = this;
	    api
	      .getConfig()
	      .then((result) => {
	        if (result.status === 200) {
	        localStorage.setItem('apiData', JSON.stringify(result.data.info));
	          
	        // that.oss1 = result.data.oss.filter(
	        //   (item) => item.location == "#/user/drawExplain002"
	        // );
	        
	         that.img= result.data.info.index;
			  
			 //  this.$dialog.alert({
			 //      message: `
			 //    <img src='https://43.100.118.139:25335/down/nb9kWtV7vgc0.png' width='80%' height='80%'/>
				// <span>商品</span>
			 //  `,
			 //    });
			 
		// 	 this.$dialog.alert({
		// 	     message: `
		// 	 <div class="image-container" style="  position: relative;
  // display: inline-block;">
		// 	   <img src='https://43.100.118.139:25335/down/nb9kWtV7vgc0.png' alt="" style="  display: block; 
  // width: 100%;
  // height: auto; " />
		// 	     <div class="text-overlay" style=" position: absolute;
  // top: 50%; /* 垂直居中 */
  // left: 50%; /* 水平居中 */
  // transform: translate(-50%, -50%); /* 微调位置确保精确居中 */
  // color: white; /* 文字颜色 */
  // font-size: 24px; /* 文字大小 */
  // background-color: rgba(0, 0, 0, 0.5); /* 可选：背景色和透明度 */
  // padding: 10px; /* 内边距 */
  // border-radius: 5px; ">你的文字</div>
		// 	   </div>
		// 	 `,
		// 	   });
			 
	        } else {
	          // document.title = "云小猪-" + to.meta.web_title;
	        }
	        console.log(result);
	      })
	      .catch((err) => {
	        throw err;
	      });
	  } catch (error) {
	    console.error(error);
	  }
	},
    // 获取最新数据
    async lottery_going_shoplist(data, type) {
      const result = await api.store_integral.lottery_going_shoplist(
        data,
        type
      );
      if (result.status == 200) {
        this.timestampWithDecimal = result.data.maxSeconds;
        console.log(result.data.listItems[0]);
        if (result.data.listItems.length > 0) {
          this.index_lottery = result.data.listItems[0];
        }
      }
    },
    // 获取开奖人员
    async finish() {
      const result = await api.store_integral.barcoderWinInfo({
        productId: this.index_lottery.sid,
      });
      if (result.status == 200) {
        this.index_lottery.user = result.data;
        this.index_lottery.times = 0;
      }
    },
    async getHttp() {
      try {
        const [open_list, index_lottery] = await Promise.all([
          this.get_open_list(),
          this.get_index_lottery(),
        ]);

        if (open_list.status == 200) {
          console.log(open_list.data);
          this.open_list = open_list.data.data[0] || null;
        }
        if (index_lottery.status == 200) {
          this.index_lottery = index_lottery.data[0] || null;
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 即将揭晓
    async get_open_list() {
      // api.store_integral.getStoreIntegral type=7&salesOrder=asc&page=1&limit=20
      return api.store_integral.getStoreIntegral({
        type: 18,
        salesOrder: "asc",
        page: 1,
        limit: 1,
      });
    },
    // 最新揭晓
    async get_index_lottery() {
      return api.store_integral.get_index_lottery({ page: 1, limit: 1 });
    },
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>


